<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :class="className"
  >
    <g>
      <path
        d="M11.1818 4.63636V9.54545C11.1818 9.97944 11.0094 10.3957 10.7025 10.7025C10.3957 11.0094 9.97944 11.1818 9.54545 11.1818H4.63636C4.20237 11.1818 3.78616 11.0094 3.47928 10.7025C3.1724 10.3957 3 9.97944 3 9.54545V4.63636C3 4.20237 3.1724 3.78616 3.47928 3.47928C3.78616 3.1724 4.20237 3 4.63636 3H9.54545C9.97944 3 10.3957 3.1724 10.7025 3.47928C11.0094 3.78616 11.1818 4.20237 11.1818 4.63636ZM19.3636 3H14.4545C14.0206 3 13.6043 3.1724 13.2975 3.47928C12.9906 3.78616 12.8182 4.20237 12.8182 4.63636V9.54545C12.8182 9.97944 12.9906 10.3957 13.2975 10.7025C13.6043 11.0094 14.0206 11.1818 14.4545 11.1818H19.3636C19.7976 11.1818 20.2138 11.0094 20.5207 10.7025C20.8276 10.3957 21 9.97944 21 9.54545V4.63636C21 4.20237 20.8276 3.78616 20.5207 3.47928C20.2138 3.1724 19.7976 3 19.3636 3ZM9.54545 12.8182H4.63636C4.20237 12.8182 3.78616 12.9906 3.47928 13.2975C3.1724 13.6043 3 14.0206 3 14.4545V19.3636C3 19.7976 3.1724 20.2138 3.47928 20.5207C3.78616 20.8276 4.20237 21 4.63636 21H9.54545C9.97944 21 10.3957 20.8276 10.7025 20.5207C11.0094 20.2138 11.1818 19.7976 11.1818 19.3636V14.4545C11.1818 14.0206 11.0094 13.6043 10.7025 13.2975C10.3957 12.9906 9.97944 12.8182 9.54545 12.8182ZM19.3636 12.8182H14.4545C14.0206 12.8182 13.6043 12.9906 13.2975 13.2975C12.9906 13.6043 12.8182 14.0206 12.8182 14.4545V19.3636C12.8182 19.7976 12.9906 20.2138 13.2975 20.5207C13.6043 20.8276 14.0206 21 14.4545 21H19.3636C19.7976 21 20.2138 20.8276 20.5207 20.5207C20.8276 20.2138 21 19.7976 21 19.3636V14.4545C21 14.0206 20.8276 13.6043 20.5207 13.2975C20.2138 12.9906 19.7976 12.8182 19.3636 12.8182Z"
        :fill="fillColor"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DashboardIcon',
  props: {
    fillColor: {
      type: String,
      default: '#fff'
    },
    width: {
      type: [Number, String],
      default: 24
    },
    height: {
      type: [Number, String],
      default: 24
    },
    class: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const className = props.class
    return {
      className
    }
  }
})
</script>
